import { useState } from 'react';
import { Aviso, Botao, Campo, Cartao } from '../../componentes/ui/index.ts';
import { api, ErroApi } from '../../lib/api.ts';

/**
 * O better-auth já expõe /api/auth/change-password nativamente (plugin
 * emailAndPassword) — não existe rota própria para isto no backend.
 */
export function TrocarSenha() {
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState(false);

  const divergem = confirmacao.length > 0 && nova !== confirmacao;

  async function trocar() {
    setErro(null);
    setSucesso(false);

    if (nova.length < 8) {
      setErro('A nova senha precisa ter ao menos 8 caracteres.');
      return;
    }
    if (nova !== confirmacao) {
      setErro('A confirmação não bate com a nova senha.');
      return;
    }

    setEnviando(true);
    try {
      await api('/api/auth/change-password', {
        metodo: 'POST',
        corpo: { currentPassword: atual, newPassword: nova, revokeOtherSessions: true },
      });
      setSucesso(true);
      setAtual('');
      setNova('');
      setConfirmacao('');
    } catch (e) {
      setErro(e instanceof ErroApi ? e.mensagem : 'Não foi possível trocar a senha.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <Cartao titulo="Minha conta">
      <form
        className="pilha"
        onSubmit={(e) => {
          e.preventDefault();
          void trocar();
        }}
      >
        <p className="campo__dica">Trocar a senha encerra suas outras sessões abertas.</p>

        {erro && <Aviso tipo="erro">{erro}</Aviso>}
        {sucesso && <Aviso tipo="sucesso">Senha alterada.</Aviso>}

        <Campo
          rotulo="Senha atual"
          type="password"
          autoComplete="current-password"
          value={atual}
          onChange={(e) => setAtual(e.target.value)}
          required
          obrigatorio
        />

        <Campo
          rotulo="Nova senha"
          type="password"
          autoComplete="new-password"
          value={nova}
          onChange={(e) => setNova(e.target.value)}
          required
          obrigatorio
          minLength={8}
          dica="Mínimo de 8 caracteres."
        />

        <Campo
          rotulo="Confirmar nova senha"
          type="password"
          autoComplete="new-password"
          value={confirmacao}
          onChange={(e) => setConfirmacao(e.target.value)}
          required
          obrigatorio
          erro={divergem ? 'As senhas não coincidem.' : null}
        />

        <Botao
          type="submit"
          carregando={enviando}
          disabled={!atual || !nova || !confirmacao || divergem}
        >
          Trocar senha
        </Botao>
      </form>
    </Cartao>
  );
}
